// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { AliasesItem } from '@shared/commons/cache/AliasesItem';
export class AliasesGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.I18N_NAMES_GROUP, null, pfixFieldSet);
        this.Data = AliasesGroup.GetFromFieldSet(pfixFieldSet);
    }
    static GetFromFieldSet(fieldSet) {
        const aliasesGroups = fieldSet.GetGroups(FieldsFactory.I18N_NAMES_GROUP);
        if (aliasesGroups.length === 0) {
            return null;
        }
        const aliases = {};
        for (let i = 0; i < aliasesGroups.length; i++) {
            const alias = aliasesGroups[i];
            const aliasesItem = new AliasesItem();
            const lang = alias.GetValue(FieldsFactory.FIELD_LANG);
            aliasesItem.Name = alias.GetValue(FieldsFactory.FIELD_NAME);
            aliasesItem.Description = alias.GetValue(FieldsFactory.FIELD_DESCRIPTION);
            aliases[lang] = aliasesItem;
        }
        return aliases;
    }
    static GetFromFieldSetOnlyName(fieldSet) {
        const aliasesGroups = fieldSet.GetGroups(FieldsFactory.I18N_NAMES_GROUP);
        if (aliasesGroups.length === 0) {
            return null;
        }
        const aliases = {};
        for (let i = 0; i < aliasesGroups.length; i++) {
            const alias = aliasesGroups[i];
            const lang = alias.GetValue(FieldsFactory.FIELD_LANG);
            const name = alias.GetValue(FieldsFactory.FIELD_NAME);
            aliases[lang] = name;
        }
        return aliases;
    }
}
